import { render, staticRenderFns } from "./SldMenuList.vue?vue&type=template&id=4279c8b7&scoped=true"
import script from "./SldMenuList.vue?vue&type=script&lang=js"
export * from "./SldMenuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4279c8b7",
  null
  
)

export default component.exports